import { apiRequest, getResource } from "../api/http";

// Push notifications of the app (/api/admin/notifications, admin token).

const BASE = "/api/admin/notifications";

export function getNotifications({ page = 1, kind, status, source } = {}) {
  const query = new URLSearchParams({ page: String(page) });
  if (kind) query.set("kind", kind);
  if (status) query.set("status", status);
  if (source) query.set("source", source);
  return getResource(`${BASE}?${query}`, {
    fallback: { items: [], total: 0, page: 1, pageSize: 20 },
  });
}

export function getNotificationsOverview() {
  return getResource(`${BASE}/overview`, { fallback: null });
}

/** Number of devices reached by an audience ({ count } or { count: null, loggedIn } for everyone). */
export function countAudience(audience) {
  return apiRequest("post", `${BASE}/audience`, {
    data: { audience },
    fallback: null,
  });
}

/** Sends now, or schedules when `scheduledAt` is in the future. Rejects with the API message. */
export function sendNotification(notification) {
  return apiRequest("post", BASE, { data: notification, rethrow: true });
}

export function cancelNotification(id) {
  return apiRequest("post", `${BASE}/${id}/cancel`, { rethrow: true });
}

export function deleteNotification(id) {
  return apiRequest("delete", `${BASE}/${id}`, { rethrow: true });
}

export function searchNotificationVideos(q = "") {
  return getResource(`${BASE}/videos?q=${encodeURIComponent(q)}`, {
    select: (data) => data.items || [],
    fallback: [],
  });
}

export function searchNotificationUsers(q = "") {
  return getResource(`${BASE}/users?q=${encodeURIComponent(q)}`, {
    select: (data) => data.items || [],
    fallback: [],
  });
}

export function getAutomations() {
  return getResource(`${BASE}/automations`, {
    select: (data) => data.items || [],
    fallback: [],
  });
}

export function updateAutomation(key, changes) {
  return apiRequest("put", `${BASE}/automations/${key}`, {
    data: changes,
    select: (data) => data.automation,
    rethrow: true,
  });
}

/** Runs an automation now, or previews it without sending with `dryRun`. */
export function runAutomation(key, { dryRun = false } = {}) {
  return apiRequest("post", `${BASE}/automations/${key}/run`, {
    data: { dryRun },
    select: (data) => data.result,
    rethrow: true,
  });
}

/** Error message returned by the API, or `fallback`. */
export const apiMessage = (error, fallback) =>
  error?.response?.data?.message || fallback;

/** Reminders by notification and/or email (quiz reminder…), shown with the automations. */
export const getReminders = () => getResource("/api/admin/notifications/reminders", { select: (data) => data.automations, rethrow: true });
/** Saves a reminder; resolves with the saved reminder. Rejects with the API message. */
export const updateReminder = (key, body) =>
  apiRequest("put", `/api/admin/notifications/reminders/${key}`, { data: body, select: (data) => data.automation, rethrow: true });
/** `{ dryRun: true }` preview, `{ testEmail }` test email, or `{}` real send now. */
export const runReminder = (key, body = {}) =>
  apiRequest("post", `/api/admin/notifications/reminders/${key}/run`, { data: body, select: (data) => data.result, rethrow: true });
